"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWithResponseType = void 0;
const axios_1 = __importDefault(require("axios"));
const getWithResponseType = (config) => {
    const source = axios_1.default.CancelToken.source();
    const promise = (0, axios_1.default)(Object.assign(Object.assign({}, config), { cancelToken: source.token })).then(({ data }) => data);
    // @ts-ignore
    promise.cancel = () => {
        source.cancel('Query was cancelled by React Query');
    };
    return promise;
};
exports.getWithResponseType = getWithResponseType;
exports.default = exports.getWithResponseType;
//# sourceMappingURL=response-type.js.map